const routers = [
    {
        path: '/all_purchase',
        name: 'all_purchase',
        meta: {
            exp: '全部拼购',
            requireAuth: false
        },
        component: () => import('@/views/all_purchase/index.vue'),
    },
    {
        path: '/details_of_purchase',
        name: 'details_of_purchase',
        meta: {
            exp: '拼购详情',
            requireAuth: false
        },
        component: () => import('@/views/all_purchase/details_of_purchase/index.vue'),
    },

]
export default routers